import moment from 'moment'

const objectToFormData = (obj, form, namespace) => {
    const fd = form || new FormData()
    let formKey

    const keys = Object.keys(obj)

    keys.forEach(property => {
        if (obj.hasOwnProperty(property)) {
            if (namespace) {
                formKey = `${namespace}[${property}]`
            } else {
                formKey = property
            }
            // if the property is an object, but not a File,
            // use recursivity.
            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, property)
            } else {
                // if it's a string or a File object
                fd.append(formKey, obj[property])
            }
        }
    })

    return fd
}

const onKeyPressNumbers = event => {
    if (!/[0-9]/.test(event.key)) {
        event.preventDefault()
    }
}
const onKeyMoney = (e, value) => {
    if (!/^\d*\.?\d*$/.test(value + e.key)) {
        e.preventDefault()
    }
}

const currencyFormat = value => {
    return Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
    }).format(value)
}

const method = type => {
    switch (type) {
        case 'cash':
            return 'Efectivo'
        case 'transfer':
            return 'Tranferencia'
        case 'credit_card':
            return 'Tarjeta de credito'
        case 'debit_card':
            return 'Tarjeta de debito'
        case 'check':
            return 'Cheque'
        case 'total':
            return 'Total'
       case 'total_invoiced':
            return 'Total facturado'
       case 'en_proceso':
            return 'En proceso'
        default:
            return type
    }
}
const methodCode = type => {
    switch (type) {
        case 'cash':
            return 'EF'
        case 'transfer':
            return 'TR'
        case 'credit_card':
            return 'T.C'
        case 'debit_card':
            return 'T.D'
        case 'check':
            return 'CH'
        case 'credit':
            return 'CR'
        case 'total':
            return 'Total'
       case 'total_invoiced':
            return 'Total facturado'
       case 'en_proceso':
            return 'En proceso'
        default:
            return type
    }
}

const calcTaxAux = (name, price, percentage, tax1, tax2) => {
    const customerTypesPercent = percentage / 100 + 1

    const p = price * customerTypesPercent // Precio sin impuestos

    const taxAmount1 = p * tax1 // Valor del primer impuesto
    const priceWithTax1 = p + taxAmount1 // Precio con el primer impuesto
    const taxAmount2 = priceWithTax1 * tax2 // Valor del segundo impuesto
    const total = priceWithTax1 + taxAmount2 // Precio con ambos impuestos

    return {
        name,
        price: p.toFixed(6),
        tax1: taxAmount1.toFixed(6),
        tax2: taxAmount2.toFixed(6),
        total: total.toFixed(6),
    }
}

const calculatePercent = (cost, price) => {
    return (price / cost) * 100;
}

const getRangesWeeks = year => {
    const tmp = []
    const date = moment(`${year}-01-01`).locale('es')

    while (date.year() === year) {
        const startOfWeek = date
            .clone()
            .startOf('isoWeek')
            .add(4, 'days')
        const endOfWeek = date
            .clone()
            .endOf('isoWeek')
            .add(4, 'days')

        if (startOfWeek.year() === year) {
            tmp.push({
                label: `Semana ${date.isoWeek()}: ${startOfWeek.format('MMMM D')} - ${endOfWeek.format('MMMM D')}`,
                start: startOfWeek.format('YYYY-MM-DD'),
                end: endOfWeek.format('YYYY-MM-DD'),
                value: date.isoWeek(),
            })
        }

        date.add(1, 'week')
    }

    return tmp
}

/**
 *
 * @param {Number} value Decimal value
 * @returns Number
 */
const percentageToDecimal = (value) => {
    // TODO: poner condicion que si value es mayor a 100 siempre sea 100 o menor a 100
    const percentage = value || 0;
    // const realPercentage = percentage > 100 ? 100 : percentage;
    return percentage / 100;

    // const decimal = (percentage + 100) / 100;
    // return decimal;
};

/**
 * Usar
 * @param {String} value Decimal value
 * @returns Number
 */
const decimalToPercentage = (value) => {
    const decimal = +value;
    const percentage = decimal * 100;

    return Math.abs(percentage);
};

const decimalToPercentageCustomerTypes = (value) => {
    const decimal = +value;
    const percentage = (decimal - 1) * 100;

    return Math.abs(percentage);
}

const percentageCustomerTypesDecimalToDecimal = (value) => {
    const percentage = +value;
    const decimal = percentage / 100 + 1;

    return Math.abs(decimal);
}

const percentageToCustomerTypePercentage = (value) => {
    const percentage = +value;
    const customerTypePercentage = percentage - 100;

    return customerTypePercentage;
}

const customerTypePercentageToPercentage = (value) => {
    const customerTypePercentage = +value;
    const percentage = customerTypePercentage + 100;

    return percentage;
}

const getBasePrice = (baseImporte, taxDecimalTotal) => baseImporte / (taxDecimalTotal + 1)

const getAmountsFromImporte = (importe, taxDecimal1, taxDecimal2, taxDecimalTotal) => {
    let price = importe;

    let taxAmount1 = 0;
    let taxAmount2 = 0;

    // if (taxDecimalTotal) {
    // }
    price = getBasePrice(importe, taxDecimalTotal);

    if (taxDecimal1) {
        taxAmount1 = price * taxDecimal1;
    }

    if (taxDecimal2) {
        taxAmount2 = price * taxDecimal2;
    }

    return {
        price, taxAmount1, taxAmount2,
    }
}

/**
 * 
 * @param {number} cost 
 * @param {number} percentage 
 * @param {number} taxDecimal1 
 * @param {number} taxDecimal2 
 * @param {number} taxDecimalTotal 
 * @param {number} [priceBeforeTax] - Base price to consider. Only used with general price type
 * @param {number} [priceAfterTax] - Final price to consider. Only used with general price type
 * @returns {Object}
 */
const getAmountsFromCost = (cost, percentage, taxDecimal1, taxDecimal2, taxDecimalTotal, priceBeforeTax = false, priceAfterTax = false) => {
    const decimal = percentageToDecimal(percentage);

    let price = cost * decimal;

    if (priceBeforeTax !== false && priceBeforeTax !== 0) {
        price = priceBeforeTax;
    }

    let importe = 0;
    let taxAmount1 = 0;
    let taxAmount2 = 0;

    if (taxDecimal1) {
        taxAmount1 = price * taxDecimal1;
    }

    if (taxDecimal2) {
        taxAmount2 = price * taxDecimal2;
    }

    // if (taxDecimalTotal) {
    // }
    importe = price * (1 + taxDecimalTotal);

    if (priceAfterTax !== false && priceAfterTax !== 0) {
        importe = priceAfterTax;
    }

    return {
        price, // Antes de impuesto
        taxAmount1,
        taxAmount2,
        importe, // Después de impuesto
    };
}

export {
    objectToFormData,
    onKeyPressNumbers,
    onKeyMoney,
    currencyFormat,
    method,
    calcTaxAux,
    calculatePercent,
    getRangesWeeks,
    percentageToDecimal,
    decimalToPercentage,
    getAmountsFromCost,
    getAmountsFromImporte,
    getBasePrice,
    decimalToPercentageCustomerTypes,
    percentageCustomerTypesDecimalToDecimal,
    percentageToCustomerTypePercentage,
    customerTypePercentageToPercentage,
    methodCode
}
